import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { FILTER_GLOBAL_KEYS, FILTER_KEYS, GAMES, PRACTICES } from '../../../config/constants';
import { useRouter } from '../../../helpers/customHooks';
import { isCC, isTA } from '../../../helpers/helpers';
import { useDataPlayersDispatch, useDataPlayersState, useFiltersState, useUserState } from '../../../store/hooks';
import { MetaDataPlayer } from '../../../store/types';
import { PlayerRoutes } from '../types';

export default ({ player } : { player: MetaDataPlayer }) => {
  const { match, location } = useRouter<PlayerRoutes>();
  const { playerId, event } = match.params;
  const user = useUserState();
  const { playerPractices = [] } = useDataPlayersState(playerId);
  const {
    [FILTER_GLOBAL_KEYS.WEEKS]: weeks,
    [FILTER_KEYS.DATE_RANGE]: filterDateRangeData
  } = useFiltersState('PLAYER_PRACTICES:'+playerId, FILTER_GLOBAL_KEYS.WEEKS, FILTER_KEYS.DATE_RANGE);
  const { getPlayerMetrics } = useDataPlayersDispatch();
  useEffect(() => {
    if (weeks && filterDateRangeData && filterDateRangeData.selectedDates && filterDateRangeData.selectedDates.length) {
      getPlayerMetrics();
    }
  }, [weeks, filterDateRangeData]);

  if (isCC(user)) {
    return (
      <div className="r-left">
        <Link
          className="radio ll-oo"
          to={{
            pathname: `/player/${playerId}/${PRACTICES}`,
            search: location.search,
            state: location.state
          }}
        >
          <input id="radio-practices" name="radio" type="radio" defaultChecked={event === PRACTICES} />
          <label htmlFor="radio-practices" className="radio-label capitalize-text">{PRACTICES}</label>
        </Link>
        <Link
          to={{
            pathname: `/player/${playerId}/${GAMES}`,
            search: location.search,
            state: location.state
          }}
        >
          <div className="radio">
            <input id="radio-games" name="radio" type="radio" defaultChecked={event === GAMES} />
            <label htmlFor="radio-games" className="radio-label capitalize-text">{GAMES}</label>
          </div>
        </Link>
      </div>
    );
  }
  if (isTA(user)) {//if player of accountteamId are not undefined
    return (
      <div className="r-left">
          <Link
            to={{
              pathname: `/player/${playerId}/${PRACTICES}`,
              search: location.search,
              state: location.state
            }}
          >
            <div className="radio ll-oo">
              <input id="radio-practices" name="radio" type="radio" defaultChecked={event === PRACTICES} />
              <label htmlFor="radio-practices" className="radio-label capitalize-text">{PRACTICES}</label>
            </div>
          </Link>
          <Link
            to={{
              pathname: `/player/${playerId}/${GAMES}`,
              search: location.search,
              state: location.state
            }}
          >
            <div className="radio">
              <input id="radio-games" name="radio" type="radio" defaultChecked={event === GAMES} />
              <label htmlFor="radio-games" className="radio-label capitalize-text">{GAMES}</label>
            </div>
          </Link>
      </div>
    );
  }
  return null;
};
